// extracted by mini-css-extract-plugin
export default {"root":"LandingSearchForm_root__2KcHA","searchSubmit":"LandingSearchForm_searchSubmit__HUV1C","desktopInput":"LandingSearchForm_desktopInput__yOQ2u"};